import { Injectable, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import { FilesValidator, NotificationMetadata } from '../file.model';
import { ReadFile } from '../read-file.model';
import { ApFileSelectorComponent } from '../selector/selector.component';

@Injectable()
export class ApAmountValidator implements FilesValidator {
    private readonly contentService = inject(ApContentService);

    public fileSelector: ApFileSelectorComponent;

    public showNotification = false;

    public getNotification(): NotificationMetadata {
        return {
            type: 'error',
            testId: 'warning-maxamount',
            content: this.contentService.get('file.selector.warning.amountExceeded', {
                fileAmount: `${this.fileSelector.maxFilesAllowed()}`
            })
        };
    }

    public validate(previousValue: ReadFile[], currentValue: ReadFile[]): boolean {
        let isValid = true;
        if (this.fileSelector.maxFilesAllowed() > 0) {
            isValid = currentValue.length <= this.fileSelector.maxFilesAllowed();
        }
        this.showNotification = !isValid;
        return isValid;
    }
}
